"use client";

import { useTranslations } from "next-intl";
import OtpInput from "@/common/otp-input.common";
import { ForgotPasswordContext } from "@/context";
import ArrowBackwardRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { Alert, Button, Card, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { generateOtp } from "@/api/user/otp-generator";
import { validateOTP } from "@/api/user/otp-validation";
import useToast from "@/hooks/useToast";

export const ResetPasswordOtpVerify = ({ mobile }) => {
  const t = useTranslations();
  const { step, setStep } = useContext(ForgotPasswordContext);
  const [otpText, setOtpText] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const { showToast } = useToast();

  // Generate OTP on mount
  useEffect(() => {
    const sendOtp = async () => {
      try {
        await generateOtp(mobile);
        setOtpSent(true);
        showToast({
          type: "success",
          message: t("OTP sent successfully"),
        });
      } catch (error) {
        showToast({
          type: "error",
          message: error?.toString() || t("Failed to send OTP"),
        });
      }
    };
    sendOtp();
  }, [mobile]);

  const onClickBack = () => {
    setStep(step - 1);
  };

  const onClickVerify = async () => {
    try {
      await validateOTP(mobile, otpText);
      showToast({
        type: "success",
        message: t("OTP verified successfully"),
      });
      setStep(step + 1);
    } catch (error) {
      showToast({
        type: "error",
        message: error?.toString() || t("OTP verification failed"),
      });
    }
  };

  return (
    <Card
      sx={{ gap: "1.5rem", maxWidth: "25rem", margin: "auto", padding: "2rem" }}
      elevation={1}
    >
      <Alert severity={otpSent ? "success" : "info"}>
        {otpSent ? t("OTP sent successfully") : t("Sending OTP...")}
      </Alert>

      <Typography variant="h4">{t("Enter Verification Code")}</Typography>
      <Typography color="light-grey" variant="body1">
        {t("We’ve sent a 6-digit code to ")} {mobile}
      </Typography>

      <div className="w-full flex flex-col gap-6">
        <div className="w-full flex flex-col gap-1">
          <OtpInput value={otpText} onChange={setOtpText} />
        </div>

        <Button
          onClick={onClickVerify}
          variant="contained"
          fullWidth
          endIcon={<SendRoundedIcon />}
        >
          {t("Verify OTP")}
        </Button>

        <Button
          variant="text"
          fullWidth
          startIcon={<ArrowBackwardRoundedIcon />}
          onClick={onClickBack}
        >
          {t("Back")}
        </Button>
      </div>
    </Card>
  );
};

export default ResetPasswordOtpVerify;
